import React from 'react';
import { useTranslation } from 'react-i18next';
import { WfProductDetails } from 'src/api/wf/models/WfProduct';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';
import { FormRow } from '../../form/FormRow';

interface ProductHeaderProps {
  product: WfProductDetails | null;
}

export const ProductHeader = ({ product }: ProductHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <h2 className="text-xl font-bold">{t('wf.statusInformationRegistration.title')}</h2>
      <h3 className="text-base font-bold">{product?.name}</h3>
      <FormRow title={t('wf.statusInformationRegistration.productNumber')}>
        {product?.productNumber ?? ''}
      </FormRow>
      <FormRow title={t('wf.statusInformationRegistration.machineNumber')}>
        {product?.unit ?? ''}
      </FormRow>
      <FormRow title={t('wf.statusInformationRegistration.lastUpdated')}>
        {product?.update ? formatJpnDate({ iso: product?.update }) : '---'}
      </FormRow>
    </div>
  );
};

export default ProductHeader;
